import { CheckCircle, Award } from 'lucide-react';

const CompetencesValidees = ({ autonomies = [] }) => {
  // Filtrer les autonomies complètement validées (tuteur + entreprise + stagiaire accepté)
  const validees = autonomies.filter(a => a.stagiaire_accepte === true);

  if (validees.length === 0) return null;

  return (
    <div className="bg-green-50 border border-green-200 rounded-lg p-4" data-testid="competences-validees">
      <h3 className="text-sm font-semibold text-green-800 mb-3 flex items-center gap-2">
        <Award className="h-4 w-4 text-green-600" />
        Compétences Validées ({validees.length})
      </h3>
      <div className="flex flex-wrap gap-2">
        {validees.map((auto, idx) => (
          <div
            key={idx}
            className="flex items-center gap-2 px-3 py-1.5 bg-green-100 border border-green-300 rounded-full"
            title={`${auto.categorie} - ${auto.sous_categorie}`}
          >
            <CheckCircle className="h-4 w-4 text-green-600" />
            <span className="text-xs font-medium text-green-800 truncate max-w-[150px]">
              {auto.sous_categorie || auto.categorie}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompetencesValidees;
